
import http from "../http";
import { _URL } from "../../config.json";
const apiEndpoint = _URL +  "/api/Db";

export function doMigrate() {
    return http.post(`${apiEndpoint}/Migrate`);
  }